export default "__VITE_ASSET__C4OIb8Ik__"